/** Security behavior names. */
export default {
  normal: { name: 'Normal' },
  ddos: { name: 'DDOS' },
};
